exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.page-title[data-v-dad0123c] { margin: -1em 0 1em; padding-right:2em;}\n.scrollable[data-v-dad0123c] { max-height: 60vh;\n}\n.logo[data-v-dad0123c]\n{\n    max-width: 20vw;\n    padding-bottom:50px;\n}\n", ""]);

